module.exports = __webpack_public_path__ + "img/live-2.ee91a253.png";